import { Alert } from '../types'

export const getAlertText = (alert?: Alert | string) => {
  if (!alert) return ''
  return typeof alert === 'string' ? alert : alert.text
}
